
// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FileText, RefreshCw, ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
// import axios from 'axios';
// import Sidebar from "../../../Temp/Sidebar/Sidebar";
// import { useAuthorization } from "../hooks/useAuthorization";
// import { Box, TextField, Tooltip, IconButton } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { FaEdit, FaEye } from "react-icons/fa";
// import { FaPen } from "react-icons/fa";
// import AssignmentPagination from './AssignmentPagination';
// import CloseIcon from "@mui/icons-material/Close";

// // Syncfusion QueryBuilder
// import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

// // Syncfusion CSS (import once in your app)
// import '@syncfusion/ej2-base/styles/material.css';
// import '@syncfusion/ej2-buttons/styles/material.css';
// import '@syncfusion/ej2-popups/styles/material.css';
// import '@syncfusion/ej2-splitbuttons/styles/material.css';
// import '@syncfusion/ej2-inputs/styles/material.css';
// import '@syncfusion/ej2-lists/styles/material.css';
// import '@syncfusion/ej2-dropdowns/styles/material.css';
// import '@syncfusion/ej2-calendars/styles/material.css';
// import '@syncfusion/ej2-navigations/styles/material.css';
// import '@syncfusion/ej2-querybuilder/styles/material.css';

// import '../../../css/Updatedstyles.css';
// import { useOutletContext, Navigate, useLocation } from "react-router-dom";

// export const ListofAssignmentExams = ({ isLookup = false, onSelectExam }) => {
//   const navigate = useNavigate();
//   const { permissionLevel, loading: authLoading } = useAuthorization();

//   const [searchTerm, setSearchTerm] = useState('');
//   const [page, setPage] = useState(1);
//   const [rows, setRows] = useState([]);
//   // const [allRows, setAllRows] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [isRefreshing, setIsRefreshing] = useState(false);
//   const [error, setError] = useState(null);

//   const [showFilters, setShowFilters] = useState(false);
//   const [filterRule, setFilterRule] = useState(null);   // only updated on "Apply"

//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

//   // Refs for uncontrolled QueryBuilder
//   const qbRef = useRef(null);
//   const currentRuleRef = useRef(null);

//   const rowsPerPage = 10;
//   const API_URL = `/coordinators/assigned-exams/`;


//   const fetchExams = async (newPage = page, rule = filterRule, newSearch = searchTerm) => {
//     setLoading(true);
//     setError(null);

//     try {
//       const response = await axios.get(API_URL, {
//         params: {
//           page: newPage,
//           pageSize: rowsPerPage,
//           search: newSearch || null,
//           filters: rule ? JSON.stringify(rule) : null
//         }
//       });

//       setRows(response.data.results || []);
//       setTotalPages(response.data.totalPages || 1);

//     } catch (err) {
//       setError(err.message || "Failed to fetch assessments");
//       setRows([]);
//       setTotalPages(1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchExams();
//   }, [page]);



//   const stringOperators = [
//     { value: 'contains', key: 'Contains' },
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'startswith', key: 'Starts With' },
//     { value: 'endswith', key: 'Ends With' },
//     { value: 'isempty', key: 'Is Empty' },
//     { value: 'isnotempty', key: 'Is Not Empty' }
//   ];

//   const numberOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'Greater Than' },
//     { value: 'lessthan', key: 'Less Than' }
//   ];

//   const dateOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'After' },
//     { value: 'lessthan', key: 'Before' },
//     { value: 'greaterthanorequal', key: 'On or After' },
//     { value: 'lessthanorequal', key: 'On or Before' },
//     { value: 'between', key: 'Between' }   // ✅ ADDED
//   ];


//   const queryBuilderColumns = [
//     { field: 'title', label: 'Assessment Title', type: 'string', operators: stringOperators },
//     { field: 'examAssignedNumber', label: 'Assignment Number', type: 'string', operators: stringOperators },
//     { field: 'departmentName', label: 'Department', type: 'string', operators: stringOperators },
//     { field: 'scheduleDate', label: 'Schedule Date', type: 'date', format: 'yyyy-MM-dd', operators: dateOperators },
//     { field: 'expiryDate', label: 'Expiry Date', type: 'date', format: 'yyyy-MM-dd', operators: dateOperators },
//   ];


//   const defaultRule = {
//     condition: 'and',
//     rules: []  // empty by default – no filter
//   };

//   // ---------- Rule evaluator (same as before) ----------
//   const evaluateRule = (rule, row) => {
//     if (!rule || !rule.rules || rule.rules.length === 0) return true;
//     const results = rule.rules.map(subRule => {
//       if (subRule.rules) return evaluateRule(subRule, row);
//       const fieldValue = row[subRule.field];
//       const operator = subRule.operator;
//       const value = subRule.value;
//       switch (operator) {
//         case 'equal': return fieldValue == value;
//         case 'notequal': return fieldValue != value;
//         case 'contains': return String(fieldValue).toLowerCase().includes(String(value).toLowerCase());
//         case 'notcontains': return !String(fieldValue).toLowerCase().includes(String(value).toLowerCase());
//         case 'greaterthan': return fieldValue > value;
//         case 'lessthan': return fieldValue < value;
//         case 'greaterthanorequal': return fieldValue >= value;
//         case 'lessthanorequal': return fieldValue <= value;
//         case 'startswith': return String(fieldValue).toLowerCase().startsWith(String(value).toLowerCase());
//         case 'endswith': return String(fieldValue).toLowerCase().endsWith(String(value).toLowerCase());
//         default: return true;
//       }
//     });
//     return rule.condition === 'and' ? results.every(Boolean) : results.some(Boolean);
//   };
//   const [currentRuleState, setCurrentRuleState] = useState(defaultRule);

//   // ---------- Helper to check if QueryBuilder has any rules ----------
//   const hasRules = (rule) => {
//     if (!rule || !rule.rules) return false;
//     return rule.rules.some(r => {
//       if (r.rules) return hasRules(r); // nested groups
//       return r.field && (r.value !== undefined && r.value !== null && r.value !== '');
//     });
//   };

//   // ---------- Handlers ----------
//   const handleSort = (key) => {
//     const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
//     setSortConfig({ key, direction });
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setFilterRule(null);
//     setPage(1);
//     fetchExams(1, null, '');
//   };

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) setPage(newPage);
//   };

//   const clearAllFilters = () => {
//     setSearchTerm('');
//     setFilterRule(null);
//     setPage(1);   // reset pagination

//     // Reset QueryBuilder UI
//     if (qbRef.current) {
//       qbRef.current.setRules({ condition: 'and', rules: [] });
//       currentRuleRef.current = { condition: 'and', rules: [] };
//     }

//     // 🔥 IMPORTANT: Call backend again
//     fetchExams(null);
//   };

//   const applyFilters = () => {
//     const rule = currentRuleRef.current;

//     setFilterRule(rule);
//     setPage(1);

//     fetchExams(1, rule, searchTerm);   // ✅ Correct
//   };
//   const { permissionSet, permissionsLoading } = useOutletContext();

//   const canAccessAssessment = permissionSet.has(1) || permissionSet.has(2);


//   useEffect(() => {
//     const delay = setTimeout(() => {
//       fetchExams(1, filterRule, searchTerm);
//       setPage(1);
//     }, 500);

//     return () => clearTimeout(delay);
//   }, [searchTerm]);

//   if (permissionsLoading) return <div>Loading...</div>;


//   if (!canAccessAssessment) {
//     return <Navigate to="/error" replace />;
//   }
//   // ---------- Render ----------
//   return (
//     <div className="flex min-h-screen">
//       {/* {!isLookup && (
//         <div className="w-[95px] flex-shrink-0">
//           <Sidebar />
//         </div>
//       )} */}

//       <div className="flex-1 overflow-auto pl-6 pr-6 pt-6">
//         <div className="pd-overview-container">

//           {/* HEADER */}
//           <div className="pd-header">
//             <div className="pd-title-section">
//               <button className="pd-back-button" onClick={() => navigate('/hr/dashboard')}>
//                 <i className="fa fa-arrow-circle-left" />
//               </button>
//               <h1 className="pd-title">Assignment configuration</h1>
//               <FileText className="pd-title-icon" />
//             </div>
//             <button onClick={handleRefresh} disabled={isRefreshing}>
//               <RefreshCw size={18} className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`} />
//             </button>
//           </div>

//           {/* SEARCH & FILTER TOGGLE */}
//           <Box className="pd-controls" sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
//             <TextField
//               size="small"
//               placeholder="Search by Assignment Title, Assignment Number, Department ...."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
//               sx={{ flexGrow: 1 }}
//             />
//             <ButtonComponent
//               cssClass="btn"
//               onClick={() => {
//                 if (showFilters) {
//                   // Clear filters when closing
//                   if (qbRef.current) {
//                     qbRef.current.setRules({ condition: 'and', rules: [] });
//                   }

//                   currentRuleRef.current = { condition: 'and', rules: [] };

//                   setFilterRule(null);
//                   setSearchTerm('');
//                   setPage(1);

//                   fetchExams(1, null, '');
//                 }

//                 setShowFilters(!showFilters);
//               }}
//             >
//               {showFilters ? 'Close Filters' : 'Enable Filters'}
//             </ButtonComponent>

//           </Box>

//           {/* QUERY BUILDER - UNCONTROLLED */}
//           {showFilters && (
//             <div style={{ marginBottom: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '8px' }}>
//               <QueryBuilderComponent
//                 ref={qbRef}
//                 dataSource={[]}
//                 columns={queryBuilderColumns}
//                 rule={defaultRule}
//                 ruleChange={(args) => { currentRuleRef.current = args.rule; setCurrentRuleState(args.rule); }}
//                 created={() => {
//                   if (qbRef.current) {
//                     qbRef.current.setRules(defaultRule);
//                   }
//                 }}
//                 showButtons={false}
//                 summaryView={false}

//               />
//               <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
//                 <ButtonComponent
//                   cssClass="btn-negative"
//                   disabled={!hasRules(currentRuleRef.current)}
//                   onClick={() => {
//                     if (qbRef.current) {
//                       qbRef.current.setRules({ condition: 'and', rules: [] });
//                       currentRuleRef.current = { condition: 'and', rules: [] };
//                     }

//                     setFilterRule(null);
//                     setSearchTerm('');
//                     setPage(1);

//                     fetchExams(1, null, '');
//                   }}
//                 >
//                   Clear Filters
//                 </ButtonComponent>
//                 <ButtonComponent cssClass="btn" disabled={!hasRules(currentRuleRef.current)} onClick={applyFilters}>
//                   Apply Filters
//                 </ButtonComponent>
//               </Box>
//             </div>
//           )}
//           {/* TABLE */}
//           <div className="pd-table-container">
//             {loading ? (
//               <div className="pd-table-loading">
//                 <div className="pd-table-loading-animation">
//                   <img
//                     className="pd-table-loading-video"
//                     src="/images/breath1.gif"
//                     alt="Loading assigned assessments..."
//                   />
//                   <p>Loading assigned assessments...</p>
//                 </div>
//               </div>
//             ) : error ? (
//               <div className="pd-no-data" style={{ color: "red" }}>
//                 Error: {error}
//               </div>
//             ) : rows.length === 0 ? (
//               <div className="pd-no-data">No assigned assessments found</div>
//             ) : (
//               <div className="pd-table-wrapper">
//                 <table className="pd-table" style={{ tableLayout: "fixed", width: "100%" }}>
//                   <thead>
//                     <tr style={{ backgroundColor: "#0191c8", color: "white" }}>
//                       <th style={{ width: "80px" }}>
//                         S.No
//                       </th>
//                       <th style={{ width: "160px" }}>
//                         Assessment Title
//                       </th>
//                       <th style={{ width: "150px" }}>
//                         Assignment Number
//                       </th>
//                       <th style={{ width: "150px" }}>
//                         Department
//                       </th>
//                       <th style={{ width: "160px" }}>
//                         Schedule Date
//                       </th>
//                       <th style={{ width: "160px" }}>
//                         Expiry Date
//                       </th>
//                       <th style={{ width: "100px" }}>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {rows.map((row, idx) => (
//                       <tr
//                         key={`${row.assignId}-${idx}`}
//                         style={{ cursor: isLookup ? "pointer" : "default" }}
//                         onClick={() => {
//                           if (isLookup && onSelectExam) {
//                             onSelectExam(row);
//                           }
//                         }}
//                       >
//                         <td>{(page - 1) * rowsPerPage + idx + 1}</td>

//                         <td
//                           style={{
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                           }}
//                           title={row.title || "Untitled"}
//                         >
//                           {row.title || "Untitled"}
//                         </td>
//                         <td>{row.examAssignedNumber || "N/A"}</td>
//                         <td>{row.departmentName}</td>
//                         <td>{row.scheduleDate || "-"}</td>
//                         <td>{row.expiryDate || "-"}</td>
//                         <td>
//                           <div className="action-wrapper">
//                             {!authLoading && permissionLevel >= 1 && (
//                               <button
//                                 onClick={() =>
//                                   navigate("/hr/employee-slots", {
//                                     state: { assignId: row.assignId },
//                                   })
//                                 }
//                                 className="pd-action-btn action-btn"
//                                 title={permissionLevel === 2 ? "Edit Assignment" : "View Assignment"}
//                               >
//                                 {permissionLevel === 2 ? <FaPen className="action-icon" /> : <FaEye className="action-icon" />}
//                               </button>
//                             )}

//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* PAGINATION */}
//           {!loading && totalPages >= 1 && (
//             <AssignmentPagination
//               page={page}
//               totalPages={totalPages}
//               handlePageChange={handlePageChange}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ListofAssignmentExams;





import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, RefreshCw, ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import axios from 'axios';
import Sidebar from "../../../Temp/Sidebar/Sidebar";
import { useAuthorization } from "../hooks/useAuthorization";
import { Box, TextField, Tooltip, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FaEdit, FaEye } from "react-icons/fa";
import { FaPen } from "react-icons/fa";
import AssignmentPagination from './AssignmentPagination';
import CloseIcon from "@mui/icons-material/Close";


// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Syncfusion QueryBuilder
import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

// Syncfusion CSS (import once in your app)
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-querybuilder/styles/material.css';

import '../../../css/Updatedstyles.css';
import { useOutletContext, Navigate, useLocation } from "react-router-dom";
import TableEmptyRow from '../../../shared/TableEmptyRow';

export const ListofAssignmentExams = ({ isLookup = false, onSelectExam }) => {
  const navigate = useNavigate();
  const { permissionLevel, loading: authLoading } = useAuthorization();

  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  // const [allRows, setAllRows] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const [showFilters, setShowFilters] = useState(false);
  const [filterRule, setFilterRule] = useState(null);   // only updated on "Apply"

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  // Refs for uncontrolled QueryBuilder
  const qbRef = useRef(null);
  const currentRuleRef = useRef(null);
  const requestIdRef = useRef(0);

  const rowsPerPage = 10;
  const API_URL = `/coordinators/assigned-exams/`;
  const formatDate = (date) => {
    if (!date) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const [referralStartDate, setReferralStartDate] = useState(null);
  const [referralEndDate, setReferralEndDate] = useState(null);
  const fetchExams = async (newPage = page, rule = filterRule, newSearch = searchTerm, startDate = referralStartDate,
    endDate = referralEndDate) => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(API_URL, {
        params: {
          page: newPage,
          pageSize: rowsPerPage,
          search: newSearch || null,
          filters: rule ? JSON.stringify(rule) : null,

          referral_start_date: formatDate(startDate),
          referral_end_date: formatDate(endDate),

        }
      });

      if (requestId !== requestIdRef.current) return;
      setRows(response.data.results || []);
      setTotalPages(response.data.totalPages || 1);

    } catch (err) {
      if (requestId !== requestIdRef.current) return;
      setError(err.message || "Failed to fetch assessments");
      setRows([]);
      setTotalPages(1);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchExams();
  }, [page]);



  const stringOperators = [
    { value: 'contains', key: 'Contains' },
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'startswith', key: 'Starts With' },
    { value: 'endswith', key: 'Ends With' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];

  const numberOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'Greater Than' },
    { value: 'lessthan', key: 'Less Than' }
  ];

  const dateOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'After' },
    { value: 'lessthan', key: 'Before' },
    { value: 'greaterthanorequal', key: 'On or After' },
    { value: 'lessthanorequal', key: 'On or Before' },
    { value: 'between', key: 'Between' }   // ✅ ADDED
  ];


const queryBuilderColumns = [
  { field: 'title', label: 'Assessment Title', type: 'string', operators: stringOperators },
  { field: 'examType', label: 'Assessment Type', type: 'string', operators: stringOperators },
  { field: 'departmentName', label: 'Department', type: 'string', operators: stringOperators },];


  const defaultRule = {
    condition: 'and',
    rules: []  // empty by default – no filter
  };

  // ---------- Rule evaluator (same as before) ----------
  const evaluateRule = (rule, row) => {
    if (!rule || !rule.rules || rule.rules.length === 0) return true;
    const results = rule.rules.map(subRule => {
      if (subRule.rules) return evaluateRule(subRule, row);
      const fieldValue = row[subRule.field];
      const operator = subRule.operator;
      const value = subRule.value;
      switch (operator) {
        case 'equal': return fieldValue == value;
        case 'notequal': return fieldValue != value;
        case 'contains': return String(fieldValue).toLowerCase().includes(String(value).toLowerCase());
        case 'notcontains': return !String(fieldValue).toLowerCase().includes(String(value).toLowerCase());
        case 'greaterthan': return fieldValue > value;
        case 'lessthan': return fieldValue < value;
        case 'greaterthanorequal': return fieldValue >= value;
        case 'lessthanorequal': return fieldValue <= value;
        case 'startswith': return String(fieldValue).toLowerCase().startsWith(String(value).toLowerCase());
        case 'endswith': return String(fieldValue).toLowerCase().endsWith(String(value).toLowerCase());
        default: return true;
      }
    });
    return rule.condition === 'and' ? results.every(Boolean) : results.some(Boolean);
  };
  const [currentRuleState, setCurrentRuleState] = useState(defaultRule);
  const valueLessOperators = new Set(['isempty', 'isnotempty', 'isnull', 'isnotnull']);

  // ---------- Helper to check if QueryBuilder has any rules ----------
  const hasRules = (rule) => {
    if (!rule || !rule.rules) return false;
    return rule.rules.some(r => {
      if (r.rules) return hasRules(r); // nested groups
      return Boolean(
        r.field &&
        r.operator &&
        (
          valueLessOperators.has(r.operator) ||
          (r.value !== undefined && r.value !== null && r.value !== '')
        )
      );
    });
  };

  // ---------- Handlers ----------
  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setFilterRule(null);
    setPage(1);
    fetchExams(1, null, '');
    setReferralStartDate(null);
    setReferralEndDate(null);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) setPage(newPage);
  };

  // const clearAllFilters = () => {
  //   setSearchTerm('');
  //   setFilterRule(null);
  //   setPage(1);   // reset pagination
  //   setReferralStartDate(null);
  //   setReferralEndDate(null);
  //   // Reset QueryBuilder UI
  //   if (qbRef.current) {
  //     qbRef.current.setRules({ condition: 'and', rules: [] });
  //     currentRuleRef.current = { condition: 'and', rules: [] };
  //   }

  //   // 🔥 IMPORTANT: Call backend again
  //   fetchExams(null);
  // };
  const clearAllFilters = () => {
    setSearchTerm('');
    setFilterRule(null);
    setPage(1);
    setReferralStartDate(null);
    setReferralEndDate(null);

    if (qbRef.current) {
      qbRef.current.setRules({ condition: 'and', rules: [] });
      currentRuleRef.current = { condition: 'and', rules: [] };
    }

    fetchExams(1, null, '', null, null);
  };

  const applyFilters = () => {
    const rule = currentRuleRef.current;

    setFilterRule(rule);
    setPage(1);

    fetchExams(1, rule, searchTerm);   // ✅ Correct
  };
  const { permissionSet, permissionsLoading } = useOutletContext();

  const canAccessAssessment = permissionSet.has(1) || permissionSet.has(2);


  useEffect(() => {
    const delay = setTimeout(() => {
      setPage(1);
      fetchExams(1, filterRule, searchTerm);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  if (permissionsLoading) return <div>Loading...</div>;


  if (!canAccessAssessment) {
    return <Navigate to="/error" replace />;
  }
  // ---------- Render ----------
  return (
    <div className="flex min-h-screen">
      {/* {!isLookup && (
        <div className="w-[95px] flex-shrink-0">
          <Sidebar />
        </div>
      )} */}

      <div className="flex-1 overflow-auto pl-6 pr-6 pt-6">
        <div className="pd-overview-container">

          {/* HEADER */}
          <div className="pd-header">
            <div className="pd-title-section">
              <button className="pd-back-button" onClick={() => navigate('/hr/dashboard')}>
                <i className="fa fa-arrow-circle-left" />
              </button>
              <h1 className="pd-title">Assignment configuration</h1>
              <FileText className="pd-title-icon" />
            </div>
            <button onClick={handleRefresh} disabled={isRefreshing}>
              <RefreshCw size={18} className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`} />
            </button>
          </div>

          {/* SEARCH & FILTER TOGGLE */}
          <Box className="pd-controls" sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
            <TextField
              size="small"
              placeholder="Search by Assessment Title, Department, Assessment Type...."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
              sx={{ flexGrow: 1 }}
            />
            <ButtonComponent
              cssClass="btn"
              onClick={() => {
                if (showFilters) {
                  // Clear filters when closing
                  if (qbRef.current) {
                    qbRef.current.setRules({ condition: 'and', rules: [] });
                  }

                  currentRuleRef.current = { condition: 'and', rules: [] };

                  setFilterRule(null);
                  setSearchTerm('');
                  setPage(1);
                  setReferralStartDate(null);
                  setReferralEndDate(null);

                  fetchExams(1, null, '');
                }

                setShowFilters(!showFilters);
              }}
            >
              {showFilters ? 'Close Filters' : 'Enable Filters'}
            </ButtonComponent>

          </Box>

          {/* QUERY BUILDER - UNCONTROLLED */}
          {showFilters && (
            <div
              style={{
                marginBottom: "20px",
                padding: "10px",
                background: "#f5f5f5",
                borderRadius: "8px",
              }}
            >

              {/* ROW 1 - Dates */}
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                }}
              >
                {/* Query Builder */}
                <Box sx={{ flex: 1 }}>
                  <QueryBuilderComponent
                    ref={qbRef}
                    dataSource={[]}
                    columns={queryBuilderColumns}
                    rule={defaultRule}
                    ruleChange={(args) => {
                      currentRuleRef.current = args.rule;
                      setCurrentRuleState(args.rule);
                    }}
                    created={() => {
                      if (qbRef.current) {
                        qbRef.current.setRules(defaultRule);
                      }
                    }}
                    showButtons={false}
                    summaryView={false}
                  />
                </Box>

                {/* Date Filters on Right Side */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 20,
                    display: "flex",
                    gap: 2,
                    zIndex: 10,
                    alignItems: "center",
                  }}
                >
                  {/* <DatePicker
                    selected={referralStartDate}
                    onChange={(date) => setReferralStartDate(date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Start Date"
                    className="form-control"
                  />
 
                  <DatePicker
                    selected={referralEndDate}
                    onChange={(date) => setReferralEndDate(date)}
                    dateFormat="yyyy-MM-dd"
                    minDate={referralStartDate}
                    placeholderText="End Date"
                    className="form-control"
                  /> */}

                  {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="From Date"
                      value={referralStartDate}
                      maxDate={new Date()}
                      onChange={(newValue) => {
                        setReferralStartDate(newValue);

                        if (
                          referralEndDate &&
                          newValue &&
                          referralEndDate < newValue
                        ) {
                          setReferralEndDate(null);
                        }
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: 170 }
                        }
                      }}
                    />

                    <DatePicker
                      label="To Date"
                      value={referralEndDate}
                      minDate={referralStartDate || undefined}
                      maxDate={new Date()}
                      onChange={(newValue) => {
                        setReferralEndDate(newValue);
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: 170 }
                        }
                      }}
                    />
                  </LocalizationProvider> */}
                </Box>
              </Box>

              {/* ROW 3 - Buttons */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  mt: 2,
                }}
              >
                <ButtonComponent
                  cssClass="btn-negative"
                  onClick={clearAllFilters}
                  disabled={
                    !hasRules(currentRuleRef.current) &&
                    !referralStartDate &&
                    !referralEndDate
                  }
                >
                  Clear Filters
                </ButtonComponent>

                <ButtonComponent
                  cssClass="btn"
                  disabled={
                    !hasRules(currentRuleRef.current) &&
                    !referralStartDate &&
                    !referralEndDate
                  }
                  onClick={applyFilters}
                >
                  Apply Filters
                </ButtonComponent>
              </Box>

            </div>
          )}
          {/* TABLE */}
          <div className="pd-table-container">
            {loading ? (
              <div className="pd-table-loading">
                <div className="pd-table-loading-animation">
                  <img
                    className="pd-table-loading-video"
                    src="/images/breath1.gif"
                    alt="Loading assigned assessments..."
                  />
                  <p>Loading assigned assessments...</p>
                </div>
              </div>
            ) : error ? (
              <div className="pd-no-data" style={{ color: "red" }}>
                Error: {error}
              </div>
            ) : (
              <div className="pd-table-wrapper">
                <table className="pd-table" style={{ tableLayout: "fixed", width: "100%" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#0191c8", color: "white" }}>
                      <th style={{ width: "80px" }}>
                        S.No
                      </th>
                      <th style={{ width: "160px" }}>
                        Assessment Title
                      </th>
                      {/* <th style={{ width: "150px" }}>
                        Assignment Number
                      </th> */}
                      <th style={{ width: "150px" }}>
                        Department
                      </th>
                      <th style={{ width: "160px" }}>
                        Assement Type
                      </th>

                      {/* <th style={{ width: "180px" }}>Completed Users</th> */}
                      <th style={{ width: "100px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length === 0 ? (
                      <TableEmptyRow colSpan={5} message="No assigned assessments found" />
                    ) : rows.map((row, idx) => (
                      <tr
                        key={`${row.assignId}-${idx}`}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate("/hr/employee-slots", {
                            // state: {
                            //   assignId: row.assignId,
                            //   mode: "view"
                            // }
                            state: {
                              examId: row.examId,
                              examTitle: row.title,
                             mode: "view"
                            }
                          })
                        }
                      >
                        <td>{(page - 1) * rowsPerPage + idx + 1}</td>

                        <td
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={row.title || "Untitled"}
                        >
                          {row.title || "Untitled"}
                        </td>
                        {/* <td>{row.examAssignedNumber || "N/A"}</td> */}
                        <td>{row.departmentName}</td>
                        <td>{row.examType || "-"}</td>

                        {/* <td>
                          {row.completedUsers ?? 0}/{row.assignedUsers ?? 0}
                        </td> */}
                        <td>
                          <div className="action-wrapper">
                            {!authLoading && permissionLevel >= 1 && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();

                                  navigate("/hr/employee-slots", {
                                    // state: {
                                    //   assignId: row.assignId,
                                    //   mode: "edit"
                                    // }
                                    state: {
                                      examId: row.examId,
                                      examTitle: row.title,
                                      mode: "edit"
                                    }
                                  });
                                }}
                                className="pd-action-btn action-btn"
                                title={permissionLevel === 2 ? "Edit Assignment" : "View Assignment"}
                              >
                                {permissionLevel === 2 ? <FaPen className="action-icon" /> : <FaEye className="action-icon" />}
                              </button>
                            )}

                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* PAGINATION */}
          {!loading && totalPages >= 1 && (
            <AssignmentPagination
              page={page}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ListofAssignmentExams;
